import { Component } from 'react';
import { addFlux, AddFluxHOCProps } from 'components/wrappers/WithFlux';
import { flux } from '../singletons';
import { Translator } from '../Translator';

interface LanguageProviderState {
  language: string;
  languages: {
    code: string;
    name: string;
  }[];
}

interface LanguageProviderProps {
  children: (e: LanguageProviderState) => any;
}

class LanguageProvider extends Component<LanguageProviderProps & AddFluxHOCProps, LanguageProviderState> {

  state = this.getStateFromStore();

  componentDidMount() {
    this.props.flux.stores.TranslationStore.on('change', this.onStoreChange);
  }

  componentWillUnmount() {
    this.props.flux.stores.TranslationStore.removeListener('change', this.onStoreChange);
  }

  getStateFromStore() {
    return {
      languages: flux.stores.TranslationStore.getLanguageCodes(),
      language: Translator.getLanguageCode().toUpperCase(),
    };
  }

  onStoreChange = () => {
    this.setState(this.getStateFromStore());
  };

  render() {
    return this.props.children(this.state);
  }
}

export default addFlux(LanguageProvider);
